<script setup lang="ts">
import type { DisciplineTutorReasonSelectOption } from '../../model/modal-discipline-tutor-change-reason.hook'

import { AppText } from '@shared/ui/typography'
import { AppMultiSelect, AppSelect } from '@shared/ui/selects'
import { ModalDefault } from '@shared/ui/modals'
import { LinkTextPrimaryMedium } from '@shared/ui/links'
import { AppTextarea } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import DisciplineTutorReasonOption from '../DisciplineTutorReasonOption.vue'
import { useModalDisciplineTutorChangeReason } from '../../model/modal-discipline-tutor-change-reason.hook'

defineOptions({
  name: 'ModalDisciplineTutorChangeReason',
})

const {
  refTitle,
  refKidName,
  refTutorName,
  refTutorUrl,
  refReasonOptions,
  refReason,
  refReasonState,
  refSubReasonOptions,
  refSubReasons,
  refComment,
  setComment,
  close,
  confirm,
} = useModalDisciplineTutorChangeReason()
</script>

<template>
  <ModalDefault
    show
    :title="refTitle"
    class-name="modal-discipline-schedule-step"
    is-close-button
    @click:overlay="close"
    @click:close="close"
  >
    <div class="modal-discipline-tutor-change-reason">
      <AppText
        name="body1"
        class="modal-discipline-tutor-change-reason__detail"
      >
        Are you sure you want to change tutor
        <LinkTextPrimaryMedium
          v-if="refTutorUrl"
          :href="refTutorUrl"
        >
          {{ refTutorName }}
        </LinkTextPrimaryMedium>
        for kid {{ refKidName }} ?
      </AppText>
      <AppSelect
        v-model="refReason"
        :options="refReasonOptions"
        label="Select reason"
        placeholder="Select here"
        :state="refReasonState"
      >
        <template #option="{ option, selected }">
          <DisciplineTutorReasonOption
            :text="option.text"
            :description="(option as DisciplineTutorReasonSelectOption).description"
            :selected="selected"
          />
        </template>
      </AppSelect>
      <AppMultiSelect
        v-if="refSubReasonOptions.length"
        :key="refReason"
        v-model="refSubReasons"
        :options="refSubReasonOptions"
        label="Select tutor performance signals"
        optional-text="Optional"
        placeholder="All"
        clearable
      />
      <AppTextarea
        label="Add comment"
        optional-label="Optional"
        placeholder="Type here..."
        :value="refComment"
        @input="setComment"
      />
    </div>
    <template #controls>
      <BtnPrimary
        text="Continue"
        color="emerald"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
<style scoped lang="scss" src="./ModalDisciplineTutorChangeReason.scss" />
